import styled from 'styled-components';
import { FontSizes } from '../typography/typography.styles';
import { RadioWrapper } from '../../features/parcel-creation/call-courier-with-sidebar/call-courier-with-sidebar.styles';
import { BREAKPOINTS } from '../../constants/breakpoints';

export const ModalRescheduleContainer = styled.div`
  ${RadioWrapper} {
    display: grid;
    grid-template-columns: 1fr 1fr;

    @media (max-width: ${BREAKPOINTS.mobile.css}) {
      display: flex;
    }
  }
`;

export const ModalRescheduleTest = styled.p`
  font-size: ${FontSizes.normal};
  font-weight: 500;
  line-height: 2rem;
  letter-spacing: 0.5px;
  margin: 2.4rem 0;
`;
